'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var delegate = require('pkg/delegate/delegate');

exports.default = delegate;